var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountSharingSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12111_26829)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.15625 12.2502C2.15617 11.4955 2.33913 10.752 2.68946 10.0835C3.03979 9.41501 3.54703 8.84146 4.16767 8.41204C4.78832 7.98262 5.50386 7.71013 6.25293 7.61795C7.002 7.52577 7.76226 7.61664 8.4685 7.88277",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.82292 7.58333C8.43375 7.58333 9.73958 6.2775 9.73958 4.66667C9.73958 3.05584 8.43375 1.75 6.82292 1.75C5.21209 1.75 3.90625 3.05584 3.90625 4.66667C3.90625 6.2775 5.21209 7.58333 6.82292 7.58333Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.86719 12.3949L12.8422 9.41992",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.86719 9.41992H12.8422V12.3949",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12111_26829",
  x: 1.65625,
  y: 1.25,
  width: 12.6875,
  height: 12.6445,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_26829"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountSharingSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfaV8xMjExMV8yNjgyOSkiPgo8cGF0aCBkPSJNMi4xNTYyNSAxMi4yNTAyQzIuMTU2MTcgMTEuNDk1NSAyLjMzOTEzIDEwLjc1MiAyLjY4OTQ2IDEwLjA4MzVDMy4wMzk3OSA5LjQxNTAxIDMuNTQ3MDMgOC44NDE0NiA0LjE2NzY3IDguNDEyMDRDNC43ODgzMiA3Ljk4MjYyIDUuNTAzODYgNy43MTAxMyA2LjI1MjkzIDcuNjE3OTVDNy4wMDIgNy41MjU3NyA3Ljc2MjI2IDcuNjE2NjQgOC40Njg1IDcuODgyNzciIHN0cm9rZT0iI0YzNUIyMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjgyMjkyIDcuNTgzMzNDOC40MzM3NSA3LjU4MzMzIDkuNzM5NTggNi4yNzc1IDkuNzM5NTggNC42NjY2N0M5LjczOTU4IDMuMDU1ODQgOC40MzM3NSAxLjc1IDYuODIyOTIgMS43NUM1LjIxMjA5IDEuNzUgMy45MDYyNSAzLjA1NTg0IDMuOTA2MjUgNC42NjY2N0MzLjkwNjI1IDYuMjc3NSA1LjIxMjA5IDcuNTgzMzMgNi44MjI5MiA3LjU4MzMzWiIgc3Ryb2tlPSIjRjM1QjIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuODY3MTkgMTIuMzk0OUwxMi44NDIyIDkuNDE5OTIiIHN0cm9rZT0iI0YzNUIyMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljg2NzE5IDkuNDE5OTJIMTIuODQyMlYxMi4zOTQ5IiBzdHJva2U9IiNGMzVCMjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2lfMTIxMTFfMjY4MjkiIHg9IjEuNjU2MjUiIHk9IjEuMjUiIHdpZHRoPSIxMi42ODc1IiBoZWlnaHQ9IjEyLjY0NDUiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeD0iMSIgZHk9IjEiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMC41Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9ImFyaXRobWV0aWMiIGsyPSItMSIgazM9IjEiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC40NjY2NjcgMCAwIDAgMCAwLjIxMTc2NSAwIDAgMCAwIDAuMTA5ODA0IDAgMCAwIDAuMjUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0ic2hhcGUiIHJlc3VsdD0iZWZmZWN0MV9pbm5lclNoYWRvd18xMjExMV8yNjgyOSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";